import { SaveButton } from "components/Buttons"
import { CheckboxField, CustomImageField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import { change, Field, formValueSelector } from "redux-form"
import { copyButtonHandler } from "utils"

const WebpageSetupTab = props => {
  return (
    <Card>
      <CardBody>
        <Row>
          <Col>
            <h6>Public Web URL for RSVP:</h6>
          </Col>
        </Row>
        <Row className="my-2">
          <Col className="align-self-center">
            {props?.selectedEvent?.rsvp_webpage_new_url}
          </Col>
          <Col xs="auto" className="align-self-center">
            <SaveButton
              content="Copy"
              color="light"
              type="button"
              size="sm"
              onClick={() => {
                copyButtonHandler(props?.selectedEvent?.rsvp_webpage_new_url)
              }}
            />
          </Col>
        </Row>
        <Row className="my-3">
          <Col xs="auto" className="align-self-center">
            <label> Banner (recommended: 1400px x 500px):</label>
          </Col>
          <Col xs="auto" className="align-self-center">
            <Field
              name="bannerImage"
              component={CustomImageField}
              onDelete={() => {
                props.change("webpage_setup.deleteBanner", 1)
              }}
            />
          </Col>
          <Col className="d-flex justify-content-end">
            {props?.bannerImage && props?.bannerImage?.editedImage && (
              <img
                src={
                  props?.bannerImage?.editedImage
                    ? props?.bannerImage?.editedImage
                    : ""
                }
                alt="bannerImage"
                className="rounded avatar-xl"
                style={{ blockSize: "auto" }}
              />
            )}
          </Col>
        </Row>
        <Row className="my-3">
          <Col>
            <Field
              name="displayBannerInfo"
              component={CheckboxField}
              label="Display information on top of the banner"
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col xs="auto">
            <SaveButton type="button" content="Save" />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const selector = formValueSelector(FORM_NAMES.EVENT_INFO)

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  bannerImage: selector(state, "webpage_setup.bannerImage"),
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.EVENT_INFO, `${field}`, value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(WebpageSetupTab)
